// Application-wide constants

export const ADMIN_COMPANY_CODE = "100100";
